import React from 'react'
import { useParams } from 'react-router-dom'

import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import * as ROUTES from 'admin/routes'

import { EditPublicApiKeyForm } from './EditPublicApiKeyForm'
import { ShortcutsModalButton } from 'admin/lib/ShortcutsModalButton'
import { Queries } from 'admin/lib/Api'

export function EditPublicApiKey() {
  const { apiKeyId } = useParams()
  const isNew = apiKeyId == 'register'

  const apiKey = Queries.useApiKey(isNew ? null : apiKeyId)

  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              {
                title: (
                  <BreadcrumbArrayItem href={ROUTES.PUBLIC_API_KEYS.LIST}>
                    Public API Keys
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: (
                  <BreadcrumbArrayItem loading={apiKey.isLoading}>
                    {isNew ? 'New' : apiKey.data?.name}
                  </BreadcrumbArrayItem>
                )
              }
            ]}
          />
          <ShortcutsModalButton />
        </>
      }
    >
      <EditPublicApiKeyForm apiKeyId={apiKeyId} isNew={isNew} />
    </Layout>
  )
}
